module.exports = __webpack_public_path__ + "static/img/ASO_fr19.bfa2923.png";


//////////////////
// WEBPACK FOOTER
// ./src/page/img/ASO_fr19.png
// module id = mKee
// module chunks = 1